import { useEffect, useState } from "react";

import { fetchHealth, type Health } from "./api/health";
import { strings } from "./brand/strings";

type State = { kind: "loading" } | { kind: "ready"; health: Health } | { kind: "error" };

/**
 * The service's own liveness, shown on the public page.
 *
 * It was the whole of the M0 client and it is kept because it answers the first question
 * anyone asks of a deployment that will not sign them in: is the back end even up.
 */
export function ServiceStatus(): React.JSX.Element {
  const [state, setState] = useState<State>({ kind: "loading" });

  useEffect(() => {
    const controller = new AbortController();
    fetchHealth(controller.signal)
      .then((health) => {
        setState({ kind: "ready", health });
      })
      .catch(() => {
        setState({ kind: "error" });
      });
    return () => {
      controller.abort();
    };
  }, []);

  return (
    <section className="q-service-status" aria-label="Service status">
      {state.kind === "loading" && (
        <p className="q-status" role="status">
          {strings.status.checking}
        </p>
      )}
      {state.kind === "error" && (
        <p className="q-alert" role="alert">
          {strings.status.failed}
        </p>
      )}
      {state.kind === "ready" && (
        <p className="q-service-status__line" data-testid="health">
          Service {state.health.status}, version {state.health.version}
        </p>
      )}
    </section>
  );
}
